var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlugin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2968 3.50745C10.2968 3.06 9.93409 2.69727 9.48664 2.69727C9.03919 2.69727 8.67646 3.06 8.67646 3.50745V6.47813H8.40639C6.16913 6.47813 4.35547 8.29179 4.35547 10.5291V15.9303C4.35547 18.7642 6.65278 21.0615 9.48664 21.0615H12.1873V23.492C12.1873 23.9395 12.55 24.3022 12.9974 24.3022C13.4449 24.3022 13.8076 23.9395 13.8076 23.492V21.0615H16.5082C19.3422 21.0615 21.6394 18.7642 21.6394 15.9303V10.5291C21.6394 8.29179 19.8258 6.47813 17.5885 6.47813H17.3184V3.50745C17.3184 3.06 16.9557 2.69727 16.5082 2.69727C16.0608 2.69727 15.6981 3.06 15.6981 3.50745V6.47813H10.2968V3.50745Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugin);
export default __webpack_public_path__ + "static/media/plugin.b459ccbbb8cd2e7e4e881c4b2356d707.svg";
export { ForwardRef as ReactComponent };